module.exports = __webpack_public_path__ + "img/gjtd.cb0b8910.png";